// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"b36fe7c2","58":"a45e7ce2","237":"a5d0e89b","468":"199caf2a","553":"f3aafad5","682":"af62f8ca","710":"841bd1d3","782":"76055b22"}[chunkId] + ".chunk.js";
};